import React from 'react';
import { motion } from 'framer-motion';
import { testimonials } from '../data/testimonials';
import { inViewOnce, reveal } from '../utils/motion';
export function TestimonialsSection() {
  return <section aria-labelledby="testimonials-heading" className="mt-5 flex flex-col gap-[30px] border-t border-black/10 pt-10 min-[700px]:mt-[30px] min-[700px]:pt-[60px]" data-id="element-125" data-mp="1n0tyt76ofxev">
      <h2 id="testimonials-heading" className="text-headline font-semibold" data-id="element-126" data-mp="1d1umnempdjn4">
        Working with me
      </h2>
      <ul className="grid grid-cols-1 gap-[30px] md:grid-cols-3" data-id="element-127" data-mp="1i0o4fj90vwt3">
        {testimonials.map((t, i) => <motion.li key={t.id} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={inViewOnce} transition={{
        ...reveal,
        delay: i * 0.06
      }} data-id="element-128" data-mp="141odg4y1f5tr" data-mpi={i}>
            <figure className="flex h-full flex-col gap-6 rounded-[30px] bg-black/[0.03] p-6" data-id="element-129" data-mp="2yfpcaptl7stu">
              <blockquote className="text-base leading-[1.6]" data-id="element-130" data-mp="32fhkv2izdyz7">
                <p data-id="element-131" data-mp="2v12l0xn2qd9l">“{t.quote}”</p>
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-4" data-id="element-132" data-mp="2uzhpp5sxqqao">
                <img src={t.photo} alt="" className="h-14 w-14 shrink-0 rounded-full object-cover" data-id="element-133" data-mp="2q1pxsbsaj46h" />
                <div className="flex flex-col text-sm leading-[1.4]" data-id="element-134" data-mp="34qujw427hsjv">
                  <span className="text-base font-semibold" data-id="element-135" data-mp="2zs1424zg5pgj">{t.name}</span>
                  <span className="text-muted" data-id="element-136" data-mp="2c2q9544s2pab">{t.role}</span>
                  <span className="text-muted" data-id="element-137" data-mp="2c2yqb87xogrb">{t.company}</span>
                </div>
              </figcaption>
            </figure>
          </motion.li>)}
      </ul>
    </section>;
}